import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

const NotFoundPage = () => (
  <div className="mx-auto max-w-3xl px-4 py-20 text-center">
    <Seo title="Page introuvable" path="/404" />
    <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Erreur 404</p>
    <h1 className="lmd-editorial-title mt-2 text-5xl font-bold text-slate-900">Page introuvable</h1>
    <p className="mt-4 text-slate-600">Le digital, expliqué autrement. Revenons a l'accueil.</p>
    <Link to="/" className="mt-8 inline-flex rounded-md bg-indigo-600 px-5 py-2.5 text-white">
      Retour a l'accueil
    </Link>
  </div>
);

export default NotFoundPage;
